import "./About.module.css";
import Header from "@/reusable_sections/Header";
import HeroSection from "./sections/HeroSection";
import ServicesGrid from "./sections/ServicesGrid";
import WhyChooseUs from "./sections/WhyChooseUs";
import CallToAction from "./sections/CallToAction";
import Googlereviewsshowcase from "./sections/Googlereviewsshowcase";
import Footer from "@/reusable_sections/Footer";
import About from "./sections/About";
export default function AboutPage() {
  return <div>
      <Header />
      <HeroSection />
      <ServicesGrid />
      <About />
      <WhyChooseUs />
      <Googlereviewsshowcase />
      <CallToAction />
      <Footer />
    </div>;
}